module.exports = __webpack_public_path__ + "img/icb-peding-01.281cae68.png";